import { Component, ViewEncapsulation, HostBinding } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-progress-bar',
	templateUrl: './progress-bar.component.html',
	styleUrls: ['./progress-bar.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ProgressBarComponent {
	@HostBinding(`class.progress-bar`) readonly className: boolean = true;

	constructor() { }
}
